"use client";

import { cn } from "@/lib/utils/cn";

type DualTabToggleProps = {
  activeTab: "financial" | "simple";
  onTabChange: (tab: "financial" | "simple") => void;
};

export function DualTabToggle({ activeTab, onTabChange }: DualTabToggleProps) {
  return (
    <div className="flex gap-1 bg-navy-mid rounded-lg p-1">
      <button
        onClick={() => onTabChange("financial")}
        className={cn(
          "flex-1 px-3 py-1.5 rounded-md text-sm font-medium transition cursor-pointer border-none",
          activeTab === "financial"
            ? "bg-blue text-white"
            : "bg-transparent text-muted-foreground hover:text-foreground"
        )}
      >
        Financial Language
      </button>
      <button
        onClick={() => onTabChange("simple")}
        className={cn(
          "flex-1 px-3 py-1.5 rounded-md text-sm font-medium transition cursor-pointer border-none inline-flex items-center justify-center gap-1.5",
          activeTab === "simple"
            ? "bg-blue text-white"
            : "bg-transparent text-muted-foreground hover:text-foreground"
        )}
      >
        Simple English
        {activeTab === "simple" && (
          <span className="bg-white/20 text-[10px] font-semibold px-1.5 py-0.5 rounded-full leading-none">
            Recommended
          </span>
        )}
      </button>
    </div>
  );
}
